// extracted by mini-css-extract-plugin
export default {"link":"Action_link__DXPVg","button":"Action_button__8j9uU"};